import { useMemo } from 'react';
import { useLocalStorage } from 'src/domain/useLocalStorage';
import { EVENT_PERFORMANCE_PAGE_CONST } from './constants';

export const useEventPerformanceSidebar = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(EVENT_PERFORMANCE_PAGE_CONST.localStorage.sidebarCollapsedKey, false);

    const layoutPaddingLeft = useMemo(() => {
        return sidebarCollapsed ? '35px' : '200px';
    }, [sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
    };
};
